import {createSelector} from '@reduxjs/toolkit';

export const policyUploadStateSelector = {
  getDivisions: () => {
    return createSelector(
      [(state: any) => state.policyUpload?.policyUploadDetails?.divisions],
      divisions => divisions,
    );
  },
  getRoles: () => {
    return createSelector(
      [(state: any) => state.policyUpload?.policyUploadDetails?.roles],
      roles => roles,
    );
  },
  getPolicyTypes: () => {
    return createSelector(
      [(state: any) => state.policyUpload?.policyUploadDetails?.policyTypes],
      policyTypes => policyTypes,
    );
  },
  getIsPolicyUploading: () => { 
    return createSelector(
      [(state: any) => state.policyUpload?.isPolicyUploading],
      isPolicyUploading => isPolicyUploading,
    );
  }
};